  if (!customElements.get('casulo-product-carousel')) {
    customElements.define('casulo-product-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.casulo-carousel__track');
        if (!this.track) return;

        this.items = [...this.track.children];
        this.controls = this.querySelector('.casulo-carousel__controls');
        this.counter = this.querySelector('.casulo-carousel__counter');
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };

        this.querySelectorAll('[data-direction]').forEach(button => {
          button.addEventListener('click', () => {
            this.move(Number(button.dataset.direction));
          }, options);
        });

        this.track.addEventListener('keydown', event => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);

        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateCounter());
        }, options);

        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.track);
        this.measure();
      }

      measure() {
        const first = this.items[0];
        if (!first) return;

        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.step = first.getBoundingClientRect().width + gap;
        this.visible = Math.max(
          1,
          Math.round((this.track.clientWidth + gap) / this.step)
        );
        this.lastIndex = Math.max(0, this.items.length - this.visible);
        this.controls.hidden = this.lastIndex === 0;
        this.updateCounter();
      }

      currentIndex() {
        if (!this.step) return 0;
        return Math.max(
          0,
          Math.min(this.lastIndex, Math.round(this.track.scrollLeft / this.step))
        );
      }

     move(direction) {
  if (!this.lastIndex) return;

  const next = Math.max(
    0,
    Math.min(this.lastIndex, this.currentIndex() + direction)
  );

  const reducedMotion = matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  this.track.scrollTo({
    left: next * this.step,
    behavior: reducedMotion ? 'auto' : 'smooth'
  });
}

updateCounter() {
  const current = this.currentIndex();

  this.counter.hidden = true;

  this.querySelectorAll('[data-direction]').forEach(button => {
    const direction = Number(button.dataset.direction);
    const unavailable =
      direction < 0
        ? current === 0
        : current >= this.lastIndex;

    button.disabled = unavailable;
    button.style.visibility = unavailable ? 'hidden' : 'visible';
  });
}

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }